import React from 'react';
import { Box, TextField } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';

const index = ({ disabled, id, name, value, help, design, onFocus, mandatory }) => {

  const handleFocus = (event, newValue) => {
    if (onFocus) {
      onFocus(event, newValue);
    }
  };

  const setValue = () => {
    if (value) {
      try {
        value = JSON.parse(value);
      } catch (error) {
        console.log(error)
      }

      value.ejecucion = new Date();
      return JSON.stringify(value);
    } else
      return null
  }
  return (

    <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>
      <Tooltip title={help} placement="top">
        <Box

          width={'500px'}

        >
          <TextField
            disabled={disabled}
            key={id}
            id={id}
            label={design !== 'table' ? <span>
              {name}
              {mandatory ? <span style={{ color: 'red' }}> *</span> : ''}
            </span> : null}
            variant="outlined"
            value={setValue()}
            //value={value}
            multiline
            fullWidth
            onFocus={(event, newValue) => handleFocus(event, newValue)}

          />
        </Box>
      </Tooltip>
    </ThemeProvider>
  )
}

export default index